import { FC } from 'react'
import { cn } from '@wellesley/ui'

const getAspectRatio = (html: string) => {
  const width = html.match(/<iframe[^>]*\bwidth="(\d+)"/i)?.[1]
  const height = html.match(/<iframe[^>]*\bheight="(\d+)"/i)?.[1]

  if (width && height) return `${width} / ${height}`

  return undefined
}

type TOEmbedHtml = {
  code: string
}

const OEmbedHtml: FC<TOEmbedHtml> = ({ code }) => {
  const aspectRatio = getAspectRatio(code)

  const aspectStyle = aspectRatio
    ? { backgroundColor: 'gray', aspectRatio: aspectRatio || '2' }
    : undefined

  return (
    <div
      data-testid="oembed-html"
      className="w-full overflow-hidden rounded-sm"
    >
      <div
        className="relative w-full"
        style={aspectStyle}
        data-aspect-ratio={aspectRatio}
      >
        <div
          className={cn(
            'h-full w-full [&>iframe]:rounded-sm [&>iframe]:border-0',
            {
              'absolute inset-0 [&>iframe]:absolute [&>iframe]:inset-0 [&>iframe]:h-full [&>iframe]:w-full ':
                aspectRatio,
            },
          )}
          dangerouslySetInnerHTML={{ __html: code }}
        />
      </div>
    </div>
  )
}

export default OEmbedHtml
